export default __webpack_public_path__ + "dcf880c0306a61d5aa81ec2960fa6e90.svg";